import React, { useRef } from "react";
import { OrangeButton } from "../../../components/OrangeButton";
import ArrowDownImg from "../../../images/Home/LandingPage/arrowDown.svg";
import Forklift from "../../../images/Home/LandingPage/forklift2.png";
import { ArrowDown, ButtonsContainer, ForkliftImg, HeaderBackground, HeaderTextContainer, LandingContainer, LandingHeader } from "./styled";

const LandingPage = () => {
  const scrollEdge = useRef(null);
  const executeScroll = () => scrollEdge.current.scrollIntoView();

  return (
    <LandingContainer>
      <HeaderBackground>
        <HeaderTextContainer>
          <LandingHeader>
            Servis, prodej a pronájem <br />
            vysokozdvižných vozíků
          </LandingHeader>
          <ButtonsContainer>
            <OrangeButton url="objednavka-servisu" text="Objednávka servisu"></OrangeButton>
            <OrangeButton url="nove-stroje" text="Prodej nových strojů"></OrangeButton>
          </ButtonsContainer>
        </HeaderTextContainer>
      </HeaderBackground>
      <ForkliftImg src={Forklift} alt="Vysokozdvižný vozík značky Toyota"></ForkliftImg>
      <ArrowDown onClick={executeScroll} src={ArrowDownImg} alt="Tlačítko sloužící pro scrollování na další obsah stránky"></ArrowDown>
      <div ref={scrollEdge}></div>
    </LandingContainer>
  );
};

export default LandingPage;
